const sideNavStyles = {
  inkfreeLogoBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pt: "4px",
    cursor: "pointer",
    width: "100%",
    transition: "padding 0.3s ease-in-out",
  },
  inkfreeLogoBoxCollapsed: {
    display: "flex",
    pt: "4px",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    width: "100%",
    transition: "padding 0.3s ease-in-out",
  },
} as const;

export default sideNavStyles;
